import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTasksMonthStatisticQuery } from '@/modules/common/queries/tasks.ts';
import { Skeleton } from 'ui';
import { GetMonthStatisticsResponse } from 'compliance-api';

interface TaskCompletionComparisonProps {
  pivotStatistic: GetMonthStatisticsResponse | undefined;
  isLoading: boolean;
}

const TaskCompletionComparison = ({ pivotStatistic, isLoading }: TaskCompletionComparisonProps) => {
  const { data: previousMonthData, isLoading: isLoadingPreviousMonthData } =
    useTasksMonthStatisticQuery({
      from_date: dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      to_date: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    });

  const completionDifference = useMemo(() => {
    if (!pivotStatistic || !previousMonthData) return 0;

    const currentPercent = pivotStatistic.completion_rate;
    const previousPercent = previousMonthData.completion_rate;

    if (!currentPercent || !previousPercent) return 0;

    return (currentPercent / previousPercent) * 100 - 100;
  }, [pivotStatistic, previousMonthData]);

  if (isLoading || isLoadingPreviousMonthData) return <Skeleton width={456} height={14} />;
  if (completionDifference === 0) return null;
  return (
    <div className="text-[14px] text-gray-500">
      {completionDifference > 0
        ? `Your task completion rate has increased by ${completionDifference.toFixed(2)}%`
        : `Your task completion rate decreased by ${Math.abs(completionDifference).toFixed(2)}%`}
    </div>
  );
};

export default TaskCompletionComparison;
